import React from "react";
import { motion } from "framer-motion";
import { GALLERY } from "@/data/site";
import { useT } from "@/i18n/LanguageContext";
import SunDivider from "./SunDivider";

export default function Gallery() {
  const { t } = useT();
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="px-6 md:px-10 lg:px-16 py-24 md:py-32"
    >
      <div className="text-center mb-12">
        <div className="font-mono-eyebrow text-[var(--text-muted)]">
          {t("Inside the office")}
        </div>
        <h2 className="font-serif-display text-[var(--primary)] mt-4 text-[44px] md:text-[64px] leading-[1.02] tracking-tight">
          {t("Discover your")}{" "}
          <span className="italic text-[var(--accent)]">{t("best")}</span> {t("smile.")}
        </h2>
        <SunDivider className="mt-5" />
        <p className="text-[var(--text-muted)] text-base max-w-md mx-auto mt-3">
          {t("A warm, family-style space with the technology you'd expect from a specialty clinic — quietly tucked out of sight.")}
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
        {GALLERY.map((src, i) => (
          <motion.div
            key={src}
            data-testid={`gallery-img-${i}`}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, delay: i * 0.05 }}
            className={`overflow-hidden rounded-3xl border border-[var(--border)] ${
              i === 0
                ? "col-span-2 row-span-2 aspect-square"
                : i === 4
                  ? "md:col-span-2 aspect-[2/1]"
                  : "aspect-[4/5]"
            }`}
          >
            <img
              src={src}
              alt="Smiles of Loudoun office"
              loading="lazy"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
